'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { logSentryError, SentryPdpMiniPdpAutoshipErrors as SentryErrors, useCustomerAutoshipSubscriptions, useDecisions } from '@libs/common-next';
import type { Product } from '@libs/common-types';
import { getAutoshipDiscountMessages, isProductAvailableForAutoship } from '../../product-details';
import { isCustomerFirstAutoshipEligible } from '../lib';
export function useMiniPdpAutoship(product) {
  const $ = _c(14);
  const isEnabled = useDecisions("as_mini_pdp");
  const {
    autoshipData,
    isReady,
    isLoading,
    isFetching,
    isError,
    error
  } = useCustomerAutoshipSubscriptions();
  const isFirstAutoshipEligible = isCustomerFirstAutoshipEligible(autoshipData);
  const hasNoSubscriptionData = isError && !autoshipData;
  let t0;
  let t1;
  if ($[0] !== error || $[1] !== isEnabled || $[2] !== isError) {
    t0 = () => {
      if (isEnabled && isError) {
        logSentryError(error, SentryErrors.MiniPdpAutoship.FetchSubscriptionsFailed);
      }
    };
    t1 = [error, isEnabled, isError];
    $[0] = error;
    $[1] = isEnabled;
    $[2] = isError;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] !== hasNoSubscriptionData || $[6] !== isEnabled || $[7] !== product) {
    t2 = isEnabled && isProductAvailableForAutoship(product) && !hasNoSubscriptionData;
    $[5] = hasNoSubscriptionData;
    $[6] = isEnabled;
    $[7] = product;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const t3 = isLoading || isFetching && isFirstAutoshipEligible;
  const t4 = !isReady;
  const t5 = getAutoshipDiscountMessages({
    isFirstAutoshipEligible,
    discountDisplay: product.autoship.discountDisplay
  });
  let t6;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = {
      shouldRender: t2,
      isLoading: t3,
      isDisabled: t4,
      messages: t5
    };
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}